import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { DataService } from 'src/app/services/data.service';
import { MatSnackBar, MatDialog, MatChipInputEvent } from '@angular/material';
import { FireValidatorsService } from 'src/app/services/fire-validators.service';
import { COLLECTION_NAME } from 'src/app/dummy/app';
import { STATUS_OBJECT, DISPLAY_STATUS_OBJECT } from 'src/app/dummy/status';
import { IDictionary } from 'src/app/interfaces/dictionary';
import { ConvertService } from 'src/app/services/convert.service';
import { DictionaryStore } from 'src/app/stores/dictionary.store';
import { AddPosWordComponent } from '../add-pos-word/add-pos-word.component';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import { AngularFirestore } from '@angular/fire/firestore';
@Component({
  selector: 'app-dictionary-form',
  templateUrl: './dictionary-form.component.html',
  styleUrls: ['./dictionary-form.component.scss']
})
export class DictionaryFormComponent implements OnInit {

  @ViewChild('focusInput', {static:false}) inputEl: ElementRef;

  ITEM_KEY: any;
  ITEM: any;
  TITLE: any = "Add new word"
  processNew: boolean = false;
  processClose: boolean = false;
  error: any = null;

  form: FormGroup;
  word: AbstractControl;
  description: AbstractControl;
  synonyms = []
  SELECTED_PICTURE_FILE: any;
  SELECTED_SOUND_FILE: any;
  isEdit: boolean = false;

  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private auth: AuthStore,
    public store: DictionaryStore,
    public ds: DataService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private afs:AngularFirestore

  ) { }

  ngOnInit() {
    this.form = this.fb.group({
      word: [null, Validators.compose([Validators.required]), this.checkExistRef.bind(this)],
      // synonyms: [null],
      phonetic: [null],
      soundfile: [null, Validators.required],
      picfile: [null]
    })

    this.route.params.subscribe(param => {
      const { id } = param;
      if (id !== 'draft') {
        this.ITEM_KEY = param.id;
        this.store.fetchSelectedData('dictionary', this.ITEM_KEY, (doc: any) => {
          if (doc) {
            this.TITLE = "Edit word"
            this.ITEM = doc;
            this.synonyms = this.ITEM.synonyms?this.ITEM.synonyms:[];
            this.isEdit = true;
            this.form = this.fb.group({
              word: [null, Validators.compose([Validators.required]), this.checkExistRef.bind(this)],
              synonyms: [null],
              phonetic: [null],
              soundfile: [null],
              picfile: [null]
            })
            const { word, synonyms, phonetic, } = doc;
            this.form.patchValue({
              word,
              phonetic,
              synonyms
            })
            this.inputEl.nativeElement.focus();
            return;
          }
          else {
            this.ITEM = null;
            this.isEdit = false;
            // this.router.navigate([`/dictionary`])
          }
        })
      }
      else {
        this.ITEM = null;
        this.ITEM_KEY = null;
      }
    })

  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    // Add our fruit
    if ((value || '').trim()) {
      this.synonyms.push({name: value.trim()});
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }
  }

  remove(synonym): void {
    const index = this.synonyms.indexOf(synonym);

    if (index >= 0) {
      this.synonyms.splice(index, 1);
    }
  }

  async checkExistRef(control: AbstractControl) {
    if (control) {
      const { value } = control
      if (!value) return null;
      if (this.ITEM) {
        const { word } = this.ITEM;
        if (word !== value) {
          const doc = await this.ds.checkExistRegisterRef(value, 'dictionary', 'word').get().toPromise();
          if (doc.empty) return null;
          return { nameAvailable: true }
        }
        return null;
      }
      else {//when draft
        const doc = await this.ds.checkExistRegisterRef(value, 'dictionary', 'word').get().toPromise();
        if (doc.empty) return null;
        return { nameAvailable: true }
      }
    }
  }
  async uploadFilePicture(event) {
    this.SELECTED_PICTURE_FILE = event.target.files[0];;
  }

  async uploadFileSound(event) {
    this.SELECTED_SOUND_FILE = event.target.files[0];;
  }


  createMorePOS(item) {
    const { word, synonyms, phonetic } = this.form.value;
    const { user, selectedCompanyKey } = this.auth;
    const data = {
      key: this.ITEM ? this.ITEM.key : this.ds.createId(),
      status: DISPLAY_STATUS_OBJECT.ACTIVE,
      isDelete: false,
      created_at: this.ITEM ? this.ITEM.created_at : new Date(),
      created_by: this.ITEM ? this.ITEM.created_by : user.uid,
      updated_at: new Date(),
      updated_by: user.uid,
      date_key: this.ITEM ? this.ITEM.date_key : ConvertService.dateKey(),
      page_key: ConvertService.pageKey(),
      keyword: word?ConvertService.toCapitalize(`${word.trim()}`):null,
      organizationRef: this.ds.companyRef().doc(selectedCompanyKey).ref,
      organizationKey: selectedCompanyKey,
      created_byRef: this.ITEM ? this.ITEM.created_byRef : this.ds.userProfileRef().doc(user.uid).ref,
      updated_byRef: this.ds.userProfileRef().doc(user.uid).ref,
      register_status: this.ITEM?this.ITEM.register_status:STATUS_OBJECT.draft,
      //fields
      word: word?word.trim():null,
      synonyms: this.synonyms?this.synonyms:[],
      phonetic: phonetic,
      pos: this.ITEM?this.ITEM.pos:null,
      pictureName: this.ITEM ? this.ITEM.pictureName : null,
      pictureUrl: this.ITEM ? this.ITEM.pictureUrl : null,
      soundName: this.ITEM ? this.ITEM.soundName : null,
      soundUrl: this.ITEM ? this.ITEM.soundUrl : null,
    }
    let dialogRef = this.dialog.open(AddPosWordComponent, {
      data:data,
      panelClass: 'item-list-panel',
      width: '',
      height: '100vh',
      disableClose: false,
      role: 'dialog',
    });
    dialogRef.updatePosition({ top: '0', right: '0', bottom: '0' });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  onSave(f: any, isDraft: boolean) {
    this.processClose = isDraft ? false : true;
    this.processNew = isDraft;
    this.error = null;
    if (this.form.valid) {
      this.form.disable();
      const { word, synonyms, phonetic } = f;
      const { user, selectedCompanyKey } = this.auth;
      const registerStatus = isDraft ? STATUS_OBJECT.draft : STATUS_OBJECT.submitted;
      const item: IDictionary = {
        key: this.ITEM ? this.ITEM.key : this.ds.createId(),
        status: DISPLAY_STATUS_OBJECT.ACTIVE,
        isDelete: false,
        created_at: this.ITEM ? this.ITEM.created_at : new Date(),
        created_by: this.ITEM ? this.ITEM.created_by : user.uid,
        updated_at: new Date(),
        updated_by: user.uid,
        date_key: this.ITEM ? this.ITEM.date_key : ConvertService.dateKey(),
        page_key: ConvertService.pageKey(),
        keyword: ConvertService.toCapitalize(`${word.trim()}`),
        organizationRef: this.ds.companyRef().doc(selectedCompanyKey).ref,
        organizationKey: selectedCompanyKey,
        created_byRef: this.ITEM ? this.ITEM.created_byRef : this.ds.userProfileRef().doc(user.uid).ref,
        updated_byRef: this.ds.userProfileRef().doc(user.uid).ref,
        register_status: registerStatus,
        //fields
        word: word.trim(),
        synonyms: this.synonyms?this.synonyms:[],
        phonetic: phonetic,
        pos: this.ITEM?this.ITEM.pos:null,
        pictureName: this.ITEM ? this.ITEM.pictureName : null,
        pictureUrl: this.ITEM ? this.ITEM.pictureUrl : null,
        soundName: this.ITEM ? this.ITEM.soundName : null,
        soundUrl: this.ITEM ? this.ITEM.soundUrl : null,

      }
      this.store.addItemWithFile(this.isEdit, 'dictionary', item, this.SELECTED_PICTURE_FILE, this.SELECTED_SOUND_FILE, this.ITEM ? this.ITEM.pictureName : null, this.ITEM ? this.ITEM.soundName : null, (success, res) => {
        if (success) {
          this.snackBar.open("dictionary has been saved successful.", "Done", { duration: 2500 });
          this.form.reset();
        }
        this.form.enable();
        this.processNew = false;
        this.processClose = false;
        this.inputEl.nativeElement.focus();
        // if (this.ITEM_KEY) {
        const status = isDraft ? 'draft' : 'submitted'
        this.router.navigate([`/dictionary/${status}`])
        // }
      })
    }
    else {
      this.inputEl.nativeElement.focus();
      this.processNew = false;
      this.processClose = false;
    }
  }

  goBack() {
    this.router.navigate(['/dictionary'])
  }

}
